import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { Field } from 'redux-form';

import { intlMessage } from 'constants/propTypes';
import { isReactElement } from 'helpers/core';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import { Form } from 'components/Form';
import Switch from 'components/Switch';

import './SmartSpotStatus.scss';

const messages = defineMessages({
  statusOn: {
    id: 'smartspot.status.on',
    defaultMessage: 'SmartSpot On',
  },
  statusOff: {
    id: 'smartspot.status.off',
    defaultMessage: 'SmartSpot Off',
  },
});

const SmartSpotStatusIndicatorDot = ({ isEnabled = false }) => (
  <span className={withMods('smartspot-status__indicator-dot', { isEnabled })} />
);

SmartSpotStatusIndicatorDot.propTypes = {
  isEnabled: PropTypes.bool,
};

const SmartSpotStatusText = ({ isEnabled = false, children }) => {
  const commonProps = {
    className: 'smartspot-status__text',
  };

  if (isReactElement(children)) {
    return React.cloneElement(children, commonProps);
  }

  let message;
  if (children) {
    message = children;
  } else if (isEnabled) {
    message = messages.statusOn;
  } else {
    message = messages.statusOff;
  }

  return <Message {...commonProps} message={message} />;
};

SmartSpotStatusText.propTypes = {
  isEnabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, intlMessage]),
};

const SmartSpotStatus = ({
  isEnabled = false,
  isDisabled = false,
  showIndicator = true,
  showText = true,
  showToggle = false,
  isSmartspotEligible,
  onSubmit,
  className,
  children,
}) => {
  if (isSmartspotEligible === false) {
    return null;
  }

  return (
    <span className={withMods('smartspot-status', className, { isDisabled })}>
      <span className="smartspot-status__text-wrap">
        {showIndicator && <SmartSpotStatusIndicatorDot isEnabled={isEnabled} />}
        {showText && <SmartSpotStatusText isEnabled={isEnabled}>{children}</SmartSpotStatusText>}
      </span>
      {showToggle && (
        <Form>
          <Field name="smartspotEnabled" component={Switch} onChange={(event, value) => onSubmit(value)} />
        </Form>
      )}
    </span>
  );
};

SmartSpotStatus.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, intlMessage]),
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isEnabled: PropTypes.bool,
  showIndicator: PropTypes.bool,
  showText: PropTypes.bool,
  showToggle: PropTypes.bool,
  onSubmit: PropTypes.func,
  isSmartspotEligible: PropTypes.bool,
};

export default SmartSpotStatus;
